import { IXCCustomerEntity } from "@/entities/IXCCustomerEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";

const entity = new IXCCustomerEntity();
export async function getPerson({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getPersonById({id}) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}
